import { call } from "redux-saga/effects";

import api from "../services/api";

export function* createContact({ payload }) {
  const { values, resolve, reject } = payload;
  const { error } = yield call(api.contacts.create, values);

  if (error) {
    reject(error);
  } else {
    resolve();
  }
}



// WEBPACK FOOTER //
// ./src/sagas/contacts.js